export default __webpack_public_path__ + "static/two-men-6481b3f2691dd8b62b420634483fa479.jpg";